// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"279":"component---src-pages-index-jsx","520":"component---src-pages-404-index-jsx"}[chunkId] + "-" + {"279":"89ddbad857c6726e4fcc","520":"f0d89f9e68ccf662022a"}[chunkId] + ".js";
};